export const ADD_PAYMENT_ERROR_MESSAGE = 'ADD_PAYMENT_ERROR_MESSAGE';
export const REMOVE_PAYMENT_ERROR_MESSAGE = 'REMOVE_PAYMENT_ERROR_MESSAGE';
